/**
 * Official brand social profiles — single source of truth for UI + copy.
 * Keep `index.html` JSON-LD (`#software` + `#organization` `sameAs`) aligned with `BRAND_SAME_AS`.
 */
export const BRAND_LINKEDIN_URL = 'https://www.linkedin.com/company/prime-document-sign/'
export const BRAND_INSTAGRAM_URL = 'https://instagram.com/primedocumentsign'
export const BRAND_YOUTUBE_URL = 'https://www.youtube.com/@primedocumentsignapp'
export const BRAND_FACEBOOK_URL = 'https://facebook.com/profile.php?id=61582265586381'

/** Canonical order for schema.org `sameAs` (LinkedIn first). */
export const BRAND_SAME_AS = [BRAND_LINKEDIN_URL, BRAND_INSTAGRAM_URL, BRAND_YOUTUBE_URL, BRAND_FACEBOOK_URL]
